import React, { Component } from 'react';
import Slider from "react-slick";
import MainPoster from '../mainPoster/MainPoster';

class ResponsiveCaraosel extends Component {

    render() {
        var settings = {
            dots: true,
            infinite: true,
            speed: 2000,
            autoplay: true,
            autoplaySpeed: 2000,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            fade: true,
            pauseOnHover: true,
        };
        return (
            <div className="container">
                <Slider {...settings}>
                    <MainPoster img={require('../../images/loading/plant.gif')} />
                    <MainPoster img={require('../../images/home/main.png')} />
                    <MainPoster img={require('../../images/home/main2.jpg')} />
                </Slider>
            </div>

        );
    }
}

export default ResponsiveCaraosel;
